// extracted by mini-css-extract-plugin
export default {"usefulOptionsLayout":"UsefulOptionsLayout_usefulOptionsLayout__nHU2o"};